export default __webpack_public_path__ + "static/media/gm-sg-girl.20c3d42e.webp";